<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { computed } from 'vue';
    import { ProtocolFormPointMap } from './coachingForm.types';

    const props = defineProps<{
        points: ProtocolFormPointMap['total'];
    }>();

    const percentage = computed(() => {
        const sectionPoints = props.points;
        if (!sectionPoints || sectionPoints.maxPoints === 0) {
            return 0;
        }
        return Number((sectionPoints.points / sectionPoints.maxPoints) * 100).toFixed(0);
    });
</script>
<template>
    <div class="rounded-lg border border-gray-light min-w-42.5 px-6.5 py-4.5">
        <p class="text-body text-left text-gray-dark mb-1">
            {{ props.points.points }}
            {{ __('coaching-form-points-of') }}
            {{ props.points.maxPoints }}
        </p>
        <h2 class="heading-xl text-left text-gray-dark">{{ percentage }}%</h2>
    </div>
</template>
